import { Download, Share2 } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { useWalletTopUpReceipt } from "../hooks/useWalletTopUpReceipt";
import type { WalletTopUp } from "../types/walletTopUps.types";

export interface WalletTopUpReceiptActionsProps {
  topUp: Pick<WalletTopUp, "id" | "reference">;
  size?: "sm" | "default";
  className?: string;
}

/** Download the PDF receipt, and share it where the platform can share files (phones, mostly). */
export function WalletTopUpReceiptActions({ topUp, size = "sm", className }: WalletTopUpReceiptActionsProps) {
  const { t } = useTranslations("walletTopUps");
  const receipt = useWalletTopUpReceipt(topUp);
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      <ColocaButton
        variant="default"
        size={size}
        icon={Download}
        loading={receipt.busy === "download"}
        disabled={receipt.busy !== null}
        onClick={() => void receipt.download()}
      >
        {t("receipt_download")}
      </ColocaButton>
      {receipt.canShare && (
        <ColocaButton
          variant="default"
          size={size}
          icon={Share2}
          loading={receipt.busy === "share"}
          disabled={receipt.busy !== null}
          onClick={() => void receipt.share()}
        >
          {t("receipt_share")}
        </ColocaButton>
      )}
    </div>
  );
}
